// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// You can define here the default values for the custom varTypes of your solution
// See ../generic/DefaultValues.js for some examples
export const CUSTOM_VAR_TYPES_DEFAULT_VALUES = {
  // myVarType: 'myDefaultValue'
};
